
export const Breakpoint = {
    lg: 840,
    md: 600,
    sm: 599
}